import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { DataMap } from '@grapecity/wijmo.grid'

import { BaseComponent, FeatureType, Grid, ListItem, ModalSize, SafetyNearMiss, VpJob } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { SafetyNearMissComponent } from './safety-near-miss.component'

@Component({
    selector: 'app-safety-near-misses',
    templateUrl: './safety-near-misses.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        GridExportComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class SafetyNearMissesComponent extends BaseComponent {
    public grid: Grid<SafetyNearMiss>

    jobMap!: DataMap
    activeJobList: ListItem<string>[] = []
    allJobs: VpJob[] = []

    constructor() {
        super()
        this.grid = new Grid<SafetyNearMiss>(this.services)
            .setupModalEditing(
                this.services.data.safetyNearMisses,
                'Near Miss Safety Investigation',
                SafetyNearMissComponent,
                () => SafetyNearMiss.createNew(),
                this,
                ModalSize.extraLarge,
            )
            .wrapColumnHeaders()
            .filterBy(item => [item.job, item.jobDisplay, item.partiesInvolved, item.description, item.correctiveAction])
        this.grid.canEdit = this.canEdit
        this.grid.canAdd = this.canEdit
        this.grid.canDelete = this.canEdit
        this.refresh()
    }

    public refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.vpJobs.queryAllByAction('GetAllJobs'),
                    this.services.data.safetyNearMisses.queryAll(),
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()

                        const allJobs = result[0] as VpJob[]
                        this.allJobs = allJobs
                        this.activeJobList = allJobs
                            .filter(job => job.jobStatus === 1)
                            .sort((a, b) => a.id.trim().localeCompare(b.id.trim(), undefined, { numeric: true }))
                            .map(job => new ListItem(job.id, `${job.id.trim()} ${job.name}`))
                        this.jobMap = new DataMap(
                            allJobs.map(j => ({ id: j.id, display: `${j.id.trim()} ${j.name}` })),
                            'id',
                            'display',
                        )

                        const items = result[1] as SafetyNearMiss[]
                        for (const item of items) {
                            item.jobDisplay = this.jobDisplayForItem(item.job)
                        }
                        this.grid.items = items
                    },
                }),
        )
    }

    jobDisplayForItem(jobId: string | null | undefined): string {
        if (!jobId) return ''
        const job = this.allJobs.find(j => j.id === jobId || j.id.trim() === jobId.trim())
        return job ? `${job.id.trim()} ${job.name}` : jobId
    }

    public get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.SafetyChecklistEdit])
    }
}
